import { useState } from "react"
import { errorToast } from "@/v2-ui/toast"
import Manage from "@/v2-backoffice-client/components/manage"
import Button from "@/v2-backoffice-client/components/button"
import { useTenantUserAddMutation } from "@/v2-backoffice-client/tenant/user/add/tenant.user.add.mutation"
import TenantCreateDialog from "@/v2-backoffice-client/tenant/create/TenantCreateDialog"
import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"
import tenantStub from "@/v2-backoffice-client/tenant/tenant.stub"
import { DEFAULT_TENANT_USER_TYPE_CODE } from "@/v2-backoffice-client/tenant/user/tenant.user.constants"

export type UserTenantManageFooterProps = {
  userId: number
  onCreated(tenant: TenantFragment): void
}

function UserTenantManageFooter(props: UserTenantManageFooterProps) {
  const { userId, onCreated } = props

  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [add, { error, loading }] = useTenantUserAddMutation()
  errorToast(error, { title: "Failed to add user to team" })

  return (
    <>
      <Manage.Footer>
        <Button
          size="xs"
          variant="ghost"
          iconSrc="plus"
          isLoading={loading}
          onClick={() => setIsCreateOpen(true)}
        >
          Create new team
        </Button>
      </Manage.Footer>

      <TenantCreateDialog
        open={isCreateOpen}
        onOpenChange={setIsCreateOpen}
        onCreated={(tenant) => {
          add({
            variables: {
              tenantId: tenant.Id,
              userId,
              userTenantTypeCode: DEFAULT_TENANT_USER_TYPE_CODE,
            },
          })
          onCreated({
            ...tenantStub,
            ...tenant,
          })
        }}
      />
    </>
  )
}

export default UserTenantManageFooter
